const namings = {
  fieldName(fieldProperties, fieldName) {
    return fieldProperties.title
      ? fieldProperties.title
      : fieldName;
  },
};
export default namings;
